import CurrencyInput from 'react-currency-input';
import styled from 'styled-components';
import variaveis from '../../styles/variaveis.scss';

export const CurrencyInputStyle = styled(CurrencyInput)`
	&:focus {
		color:  ${variaveis.selectHover};
		background-color: hsl(0,0%,100%);
		border-color: ${variaveis.selectHover}!important;
		box-shadow:  none!important;
		outline: 0;
		border-radius: 4px;
		border-style: solid;
		border-width: 1px;
	}

	&:hover {
		border-color: ${variaveis.selectHover};
	}
`;
